import React, { useState, createContext, useContext } from 'react'
import clx from 'classnames'
import { Row, Col, Grid } from 'antd'
import Header from '../Header'
import Toast from '../Toast'
import Workspace from '../Workspace'
import styles from './index.css'

const { useBreakpoint } = Grid

const SupplierInfoHoverContext = createContext()
const useSupplierInfoHoverDefault = {
  isSupplierInfoHover: false,
  setIsSupplierInfoHover: () => {}
}
export const useSupplierInfoHover = () => {
  return useContext(SupplierInfoHoverContext) || useSupplierInfoHoverDefault
}
const withSupplierInfoHoverProvider = Component => props => {
  const [isSupplierInfoHover, setIsSupplierInfoHover] = useState(false)

  const updateIsSupplierInfoHover = state => {
    if (state === isSupplierInfoHover) {
      return
    }

    setIsSupplierInfoHover(state)
  }

  return (
    <SupplierInfoHoverContext.Provider
      value={{
        isSupplierInfoHover,
        setIsSupplierInfoHover: updateIsSupplierInfoHover
      }}
    >
      <Component
        isSupplierInfoHover={isSupplierInfoHover}
        {...props}
      />
    </SupplierInfoHoverContext.Provider>
  )
}

const FullRow = props => (
  <Row
    className={styles.fullRow}
    wrap={false}
  >
    <Col flex='auto'>{props.children}</Col>
  </Row>
)

const HorizontalLayout = props => {
  const {
    page,
    children,
    render,
    actions
  } = props
  const { user, toast = {} } = page || {}
  const screens = useBreakpoint()

  const renderChildren = () => {
    if (render) {
      return render()
    }

    if (typeof children === 'function') {
      return children()
    }

    return children
  }

  return (
    <>
      {toast && toast.active && (
        <FullRow>
          <Toast
            toast={toast}
            switchToast={actions.switchToast}
          />
        </FullRow>
      )}
      <FullRow>
        <Header
          user={user}
          page={page}
          className={clx(
            styles.header,
            { [styles.mobileHeader]: !screens.lg }
          )}
          {...props}
        />
      </FullRow>
      <FullRow>
        <div className={styles.pageTitle}>
          營運看板
        </div>
      </FullRow>
      <FullRow>
        <div className={styles.rightContent}>
          <Workspace
            tag='main'
            className={styles.workspace}
          >
            {/* 主要子組件 */}
            {renderChildren()}
          </Workspace>
        </div>
      </FullRow>
    </>
  )
}

export default withSupplierInfoHoverProvider(HorizontalLayout)
